
import { Component, Vue } from 'vue-property-decorator'
import { cloneDeep, merge } from 'lodash'
import AppEditableHeader from '@/components/AppEditableHeader.vue'
import PartnerFormAccessData from '@/components/PartnerFormAccessData.vue'
import PartnerFormCompanyData from '@/components/PartnerFormCompanyData.vue'
import PartnerFormContactsData from '@/components/PartnerFormContactsData.vue'
import PartnerFormOptionalData from '@/components/PartnerFormOptionalData.vue'
import PartnerFormSavingModal from '@/components/PartnerFormSavingModal.vue'
import { partnerEntity } from '@/models/models'

@Component({
    name: 'PartnerForm',
    components: {
        AppEditableHeader,
        PartnerFormAccessData,
        PartnerFormCompanyData,
        PartnerFormContactsData,
        PartnerFormOptionalData,
        PartnerFormSavingModal,
    },
})

export default class PartnerForm extends Vue {
    private partner: PartnerEntity = cloneDeep(partnerEntity)
    private showCreatingPartnerModal: boolean = false
    private showDeactivatingPartnerModal: boolean = false
    private isEditing: boolean = false

    get isLoading(): boolean {
        return this.$store.state.partnerForm.isLoading
    }

    get headerText(): string {
        return this.isEditing ? 'Editar parceiro' : 'Adicionar parceiro'
    }

    get savePartnerErrorAlertText(): string {
        return this.isEditing ?
            'Ocorreu um erro ao tentar atualizar parceiro de integração' :
            'Ocorreu um erro ao tentar criar parceiro de integração'
    }

    public async mounted() {
        const paramId: number = parseInt(this.$route.params.id ?? 0, 10)
        this.isEditing = paramId > 0

        const responseGetPartner = await this.$store.dispatch('partnerForm/getPartner', paramId)

        if (responseGetPartner !== null) {
            this.partner = merge(this.partner, responseGetPartner)
        }
    }

    public async onClickSave() {
        if (this.isEditing && this.partner!.apikey!.status === 'INACTIVE') {
            this.showDeactivatingPartnerModal = true
            return
        }

        await this.onSave()
    }

    public onCancelModal() {
        this.showCreatingPartnerModal = false
        this.showDeactivatingPartnerModal = false
    }

    public onClose() {
        if (document.referrer.indexOf(window.location.host) !== -1) {
            this.$router.back()
        } else {
            this.$router.push('/partners')
        }
    }

    public async onSave() {
        const responseSavePartner = await this.$store.dispatch('partnerForm/savePartner', this.partner)
        this.onCancelModal()

        if (responseSavePartner == null) {
            alert(this.savePartnerErrorAlertText)
            return
        }

        this.partner = responseSavePartner

        if (this.partner.errors != null && Object.keys(this.partner.errors).length > 0) {
            alert('Há alguns campos que precisam ser corrigidos')
            return
        }

        if (!this.isEditing) {
            this.showCreatingPartnerModal = true
            return
        }

        this.onClose()
    }
}
